import {gsap} from "gsap";
import {DasUBoot} from "../../DasUBoot";
import {DasUBootGameAssets} from "../../DasUBootGameAssets";
import {SpineGSAPWrapper} from "../../../core/animation/SpineGSAPWrapper";

/**
 * Created by jonas on 2021-03-10.
 */



export enum MiniLampState {
    GREEN = "green",
    RED = "red",
    YELLOW = "yellow",
    OFF = "off"
}

export enum LampState {
    OFF = "off",
    ON = "on",
    ON_LOGO = "onLogo",
}

export class SpineLamp extends PIXI.Container {

    protected value:number;
    protected _spine:PIXI.spine.Spine;
    private state:LampState;
    private miniLampState:MiniLampState;

    constructor(spinePath:string = DasUBootGameAssets.LAMP_X_WAYS) {
        super();

        this._spine = new PIXI.spine.Spine(DasUBoot.assetLoader.getSpineAsset(spinePath));
        this.addChild(this._spine);
        this.setValue(-1);

    }

    public set tint(value:number) {
        this._spine.tint = value;
    }
    public get tint():number {
        return this._spine.tint;
    }


    public setMiniLampState(state:MiniLampState){
        if (state == this.miniLampState) {
            return;
        }

        if (state == MiniLampState.OFF){
            this.miniLampState = state;
            SpineGSAPWrapper.clearAnimation(this._spine, 1);
        } else  {
            this.miniLampState = state;
            SpineGSAPWrapper.createTimeline(this._spine, 1, state, -1);
        }
    }

    public setState(state:LampState):void {
        if (state == this.state) {
            return;
        }

        this.state = state;
        SpineGSAPWrapper.createTimeline(this._spine, 0, state, -1);

    }


    public incrementValue(increment:number, finalValue?:number):gsap.core.Timeline {
        this.value = this.value <= 0 ? 1 : this.value;
        this.value += increment;
        return this.setValue(this.value, true, finalValue);
    }

    public setValue(value:number, animated:boolean = false, finalValue?:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        this.value = value;

        let state = LampState.OFF;

        if (this.value >= 0){
            state = LampState.ON_LOGO;
        }

        tl.add(()=>this.setState(state))


        tl.add(gsap.to(this, {duration:0.001}));
        return tl;
    }




}